import { Video } from './../models/video';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable, of } from 'rxjs';
import { Article } from 'src/app/models/article';
import { Survey } from '../models/survey';
import { Result, ResultResponse } from '../models/result';
import { Advisor } from '../models/advisors';
import { Manager } from '../models/managers';
import { ClientServices } from '../models/clientServices';
import { ChartPackage } from '../models/chart';
import { catchError, map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class DataServiceService {

apiUrl = 'https://data2.ifa.com/'
chartUrl = 'https://data.ifa.com/'

constructor(private http: HttpClient) { }

getSurvey(surveyId: number) : Observable<Survey[]> {
  let url = `${this.apiUrl}api/v1/survey/${surveyId}`
// $&(url)
  return this.http.get<Survey[]> (url)
}

// survey answer question
surveyUpdateResponse(data) {
  var promise = this.http.post("https://data2.ifa.com/api/v1/survey/update-response/", data)
  
  return promise

}

//survey finish
surveyFinish(surveyResultId) {
  var promise = this.http.post("https://data2.ifa.com/api/v1/survey/finish/", surveyResultId)
  
  return promise
}

//profile finish
profileFinish(surveyResultId) {
  var promise = this.http.post("https://data2.ifa.com/api/v1/survey/result/", surveyResultId)
  
  return promise
}

//profile results
surveyResults(resultId: number) : Observable<Result> {
  var promise =  this.http.post<ResultResponse>("https://data2.ifa.com/api/v1/survey/result/", resultId).pipe(map((x:ResultResponse) => {
    return x.result
  }))
  return promise
}

getArticle(query="") : Observable<Article[]> {
  let url = `${this.apiUrl}odata/v1/articles/`
  
  //--------------------------------------------//
  //WARNING: DO NOT AD ANY MORE EXCEPTIONS TO THE QUERY FOR INDIVIDUAL ITEMS. PLEASE DUPLICATE THE ARTICLE / VIDEO AND BRAND SPECIFICALLY FOR IFC. WAIT FOR FURTHER SOFTWARE TO ALLOW MULTIPLE SITEGROUP SELECTION
  url+= "?$filter=(sitegroup eq 'www.investingforcatholics.com' and (video eq null or video eq ''))" //5326 is an article that appears on IFA.com as well
  //--------------------------------------------//

  url+= "&$orderby=date desc"
  url+= query
  return this.http.get<Article[]> (url)
} 

getArticleDetails(friendlyUrl) : Observable<Article> {
  let url = `${this.apiUrl}odata/v1/articles/${friendlyUrl}`
  return this.http.get<Article> (url) 

}

getVideo(query="") : Observable<Article[]> {
  let url = `${this.apiUrl}odata/v1/articles/`
  //--------------------------------------------//
  //WARNING: DO NOT AD ANY MORE EXCEPTIONS TO THE QUERY FOR INDIVIDUAL ITEMS. PLEASE DUPLICATE THE ARTICLE / VIDEO AND BRAND SPECIFICALLY FOR IFC. WAIT FOR FURTHER SOFTWARE TO ALLOW MULTIPLE SITEGROUP SELECTION
  url+= "?$filter=(sitegroup eq 'www.investingforcatholics.com' and (video ne null and video ne ''))" //5150, 4927, 4926, 4924, 4921 are videos that appears on IFA.com as well
  //--------------------------------------------//

  url+= "&$orderby=date desc"
  url+= query
  return this.http.get<Article[]> (url).pipe(map((x:Article[]) => {
// $&("Videos",x)
    return x.filter(y=>(y.video != null && y.video.length > 0))
  }))

}

getVideoDetails(friendlyUrl) : Observable<Article> {
  let url = `${this.apiUrl}odata/v1/articles/${friendlyUrl}`
  return this.http.get<Article> (url) 

}
getAllVideos(){
 return forkJoin([
    this.getVideo().pipe(
      map( (array:any) => { 
          return array.map(x=>{
            //console.log("getVideo > ", x)
            x.posterUrl?(x.posterUrl = x.posterUrl.replace('http://', 'https://').replace("177x100", "512x288")):(null); 
            if(x.imageUrl==null || x.imageUrl==''){
              if(x.posterUrl!=null&&x.posterUrl!=''){
                x.imageUrl = x.posterUrl;
              }
              else if(x.video){
                x.posterUrl = `https://img.youtube.com/vi/${x.video}/hqdefault.jpg`
                x.imageUrl = `https://img.youtube.com/vi/${x.video}/hqdefault.jpg`
              }
            }
            return x;
        });
      }),
      catchError(err => of("There was an error getting video."))
      ),
    this.getVideos().pipe(
      map( (array:any) => { 
        return array.map(x=>{
           // console.log("getVideos >", x);
            x.posterUrl?(x.imageUrl = x.imageUrl.replace('http://', 'https://').replace("177x100", "512x288")):(null);
          if(x.imageUrl==null || x.imageUrl==''){
            if(x.video){
              x.imageUrl = `https://img.youtube.com/vi/${x.video}/hqdefault.jpg`
            }
          }
          return x 
        });
       }),
      catchError(err => of("There was an error getting videos."))
      ),
    ])
}

videosByCategory$(query:string=""){
  return this.http.get<any>(`https://data2.ifa.com/odata/v1/videos/categories_ifc${query}`);
}

getVideos(query="") : Observable<Video[]> {

  const videoIds = [
    5411, 5225
    ]

  let url = `${this.apiUrl}odata/v1/videos/`
  url+= "?$filter=(sitegroup eq 'www.ifa.tv' and (video ne null and video ne '')) and id_other in ("+videoIds.join(',')+")" //sitegroup eq 'www.investingforcatholics.com' needs to be created
  url+= "&$orderby=date desc"
  url+= query
  return this.http.get<Video[]> (url).pipe(map((x:Video[]) => {
    return x.filter(y=>(y.video != null && y.video.length > 0) || videoIds.indexOf(y.id_other)>-1).map(y => {
      if(y.sitegroup=="www.ifa.tv"){
        y.imageUrl = `https://services.ifa.com/videos/images/${y.video}.jpg`;
      }
      else if(y.sitegroup=="www.investingforcatholics.com"){
        if((y.posterUrl==null || y.posterUrl=='') && (y.imageUrl==null || y.imageUrl=='')){
          y.imageUrl = `https://img.youtube.com/vi/${y.video}/hqdefault.jpg`
        }
      }
      return y;
    })
  }))

}

getVideosDetails(friendlyUrl) : Observable<Video[]> {
  let url = `${this.apiUrl}odata/v1/videos/${friendlyUrl}`
  return this.http.get<Video[]> (url).pipe(map((x:any) => {
// $&("getVideosDetails",x, x.length);
    
    x.imageUrl = `https://services.ifa.com/videos/images/${x.video}.jpg`;
    return [x];
    // return x.map(y => {
    //   y.imageUrl = `https://services.ifa.com/videos/images/${y.video}.jpg`;
    //   return y;
    // })
  }))

}

getAdvisor(query="") : Observable<Advisor[]> {

  // const advisorIds = [1, 28]

  let url = `${this.apiUrl}odata/v1/advisor/${query}`
  // url+= "?$filter=id in ("+advisorIds.join(',')+")" 
  // url+= query
  return this.http.get<Advisor[]> (url)
}

getManager(query="") : Observable<Manager[]> {

  // const advisorIds = [1, 28]

  let url = `${this.apiUrl}odata/v1/management/${query}`
  // url+= "?$filter=id in ("+advisorIds.join(',')+")" 
  // url+= query
  return this.http.get<Manager[]> (url)
}

getClientServices(query="") : Observable<ClientServices[]> {

  // const advisorIds = [1, 28]

  let url = `${this.apiUrl}odata/v1/clientServices/${query}`
  // url+= "?$filter=id in ("+advisorIds.join(',')+")" 
  // url+= query
  return this.http.get<ClientServices[]> (url)
}

getChart(chartId: number) : Observable<ChartPackage> {
  let url = `${this.chartUrl}api/chart/package/${chartId}`
  
  //console.log(url)
  
  return this.http.get<ChartPackage> (url).pipe(map((x:any) => {
    let cp = new ChartPackage()
    cp.dtoToClassMap(x)
    return cp
  }))
}


}
